import React, { useEffect, useState } from 'react';
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from '../firebase';
import './index.css';
import Modal from '../modal';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const CRMPage = () => {
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
const [remarks, setRemarks] = useState('');
const [selectedEntry, setSelectedEntry] = useState(null);
const navigate = useNavigate();

  const fetchCRMData = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "formsdata"));
      const records = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setData(records);
    } catch (error) {
      console.error("Error fetching Firestore data:", error);
    }
  };

  useEffect(() => {
    fetchCRMData();
  }, []);

//   const markAsConsulted = async (entry) => {
//     const remarks = prompt(`Enter remarks for ${entry.fullName}:`);
//     if (!remarks) return;

//     try {
//       const docRef = doc(db, "formsdata", entry.id);
//       await updateDoc(docRef, {
//         consulted: 'YES',
//         remarks: remarks
//       });
//       fetchCRMData(); // refresh UI
//     } catch (error) {
//       console.error("Error updating Firestore:", error);
//     }
//   };

const markAsConsulted = (entry) => {
    setSelectedEntry(entry);
    setRemarks('');
    setModalOpen(true);
  };

  const clickLogout = () => {
    Cookies.remove('ddabroad_google_email');
    navigate('/login');
  }

  const handleModalSubmit = async () => {
    if (!selectedEntry) return;
  
    try {
      const docRef = doc(db, "formsdata", selectedEntry.id);
      await updateDoc(docRef, {
        consulted: 'YES',
        remarks: remarks
      });
      setModalOpen(false);
      setSelectedEntry(null);
      fetchCRMData();
    } catch (error) {
      console.error("Error updating Firestore:", error);
    }
  };

  const consulted = data.filter(entry => entry.consulted === 'YES');
  const notConsulted = data.filter(entry => entry.consulted !== 'YES');

  const renderCard = (entry, isConsulted) => (
    <div key={entry.id} className="crm-card">
      <strong>{entry.fullName || 'No Name'}</strong>
      📧 {entry.emailAddress || 'No Email'}<br />
      📱 {entry.mobileNumber || 'No Mobile'}<br />
      🌍 {(entry.countriesOfInterest || []).join(', ')}<br />
      🔁 Referral: {entry.referralSource || 'N/A'}<br />
      {entry.remarks && <p><strong>Remarks:</strong> {entry.remarks}</p>}
      {!isConsulted && (
        <button onClick={() => markAsConsulted(entry)} className="consult-btn">
          Mark as Consulted
        </button>
      )}
    </div>
  );

  return (
    <div className="crm-container">
      <h2>CRM Dashboard</h2>
      <button onClick={clickLogout} className='logout-button'>Logout</button>
      <div className="crm-columns">
        <div className="crm-column">
          <h3>Pending Consulted</h3>
          {notConsulted.length ? notConsulted.map(entry => renderCard(entry, false)) : <p>No entries</p>}
        </div>

        <div className="crm-column">
          <h3>Closed Consulted</h3>
          {consulted.length ? consulted.map(entry => renderCard(entry, true)) : <p>No entries</p>}
        </div>
      </div>
      <Modal
  isOpen={modalOpen}
  onClose={() => setModalOpen(false)}
  onSubmit={handleModalSubmit}
  remarks={remarks}
  setRemarks={setRemarks}
  name={selectedEntry?.fullName}
/>
    </div>
  );
};

export default CRMPage;
